import React,{useEffect,useState} from 'react';
import ListItem from '../components/ListItem';
import Header from '../components/Header';
import BlogSidebar from '../components/BlogSidebar';
import {allStates,replaceAll,replaceAllByArray} from '../components/Helper';
import CommunityItem from '../components/CommunityItem';
import { BrowserRouter as Router,Routes, Route, Link,useParams } from 'react-router-dom';
import '../App.css';


const BlogDetail=()=>{

let { state } = useParams();

const [data, setData] = useState(null);
const [counties, setCounties] = useState([]);
const [foundState, setFoundState] = useState([]);


const dataFetch = async () => {

  if(typeof state === 'undefined'){
    state='';
  }
  var blogUrl=window.location.href.split('/');
  blogUrl=blogUrl[blogUrl.length-1];
  console.log(blogUrl);
  fetch('https://api.hudhousingnetwork.com/1/blog/'+blogUrl)
        .then(response => response.json())
        .then((data) =>{
          console.log(data);
          setData(data);
          
          }
        );
};


useEffect(()=>{
 console.log('Loaded!');  
 console.log();
 dataFetch();

},[]);

const setClick=(val)=>{
  var url='/community-action-center/';
  url=url+val;
  window.location.href=url;
  //console.log("clicked "+val.toLowerCase())
}

const DisplayView=()=>{
  console.log("OK")
  console.log(data);
  if(data==null)return (<div style={{fontSize:'20px',marginTop:30,textAlign:'center',width:'100%',color:'#666',fontWeight:'bold'}}>Loading Page...</div>);
  if(data.success==1){
    return (<DetailView item={data.rows[0]} />);
  }else{
    return (<div style={{fontSize:'20px',marginTop:30,textAlign:'center',width:'100%',color:'#666',fontWeight:'bold'}}>Page Not Found!</div>);
  }
  

}
const DetailView=(props)=>{
  return(
    <>
    <div className="main-content" style={{maxWidth:'100%'}}>
      <div className="top-area">
        <h2 className="top-heading">{props.item.post_title}</h2>
        <div className="author-detail">
          <div className="author-bio">
            <div className="blog-person"><img src="/img/blog-person.png" /></div>
            <div className="writtenby">Written By: <span>{props.item.firstname} {props.item.lastname}</span></div>
          </div>
          <div className="author-social-icons">
            <img src="/img/twitter-disable.png" />
            <img src="/img/twitter-disable.png" />
            <img src="/img/twitter-disable.png" />
          </div>
        </div>
        <div className="article-content" dangerouslySetInnerHTML={{__html:props.item.post_content}}></div>
      </div>

    </div>
    </>


    );
}


return (
<>
  <Header />
  <div className="content_wrapper">
    <DisplayView />      
    {/*}<BlogSidebar />{*/}
  </div>
  <div className="recent-articles">
    <h2>Recent Articles</h2>
    <div className="row">
      <div className="column">
        <div className="blogbox">
          <h3>Blog Article Title</h3>
          <p>Article snippet describing the basic information of the blog article</p>
          <div className="blog-person"><img src="/img/blog-person.png" /></div>
          <div className="writtenby">Written By: <span>Author Name</span></div>
          <button className="blog-readmore">Read More</button>
        </div>
      </div>

      <div className="column">
        <div className="blogbox">
          <h3>Blog Article Title</h3>
          <p>Article snippet describing the basic information of the blog article</p>
          <div className="blog-person"><img src="/img/blog-person.png" /></div>
          <div className="writtenby">Written By: <span>Author Name</span></div>
          <button className="blog-readmore">Read More</button>
        </div>
      </div>

      <div className="column">
        <div className="blogbox">
          <h3>Blog Article Title</h3>
          <p>Article snippet describing the basic information of the blog article</p>
          <div className="blog-person"><img src="/img/blog-person.png" /></div>
          <div className="writtenby">Written By: <span>Author Name</span></div>
          <button className="blog-readmore">Read More</button>
        </div>
      </div>

      <div className="column">
        <div className="blogbox">
          <h3>Blog Article Title</h3>
          <p>Article snippet describing the basic information of the blog article</p>
          <div className="blog-person"><img src="/img/blog-person.png" /></div>
          <div className="writtenby">Written By: <span>Author Name</span></div>
          <button className="blog-readmore">Read More</button>
        </div>
      </div>

      <div className="column">
        <div className="blogbox">
          <h3>Blog Article Title</h3>
          <p>Article snippet describing the basic information of the blog article</p>
          <div className="blog-person"><img src="/img/blog-person.png" /></div>
          <div className="writtenby">Written By: <span>Author Name</span></div>
          <button className="blog-readmore">Read More</button>
        </div>
      </div>

      <div className="column">
        <div className="blogbox">
          <h3>Blog Article Title</h3>
          <p>Article snippet describing the basic information of the blog article</p>
          <div className="blog-person"><img src="/img/blog-person.png" /></div>
          <div className="writtenby">Written By: <span>Author Name</span></div>
          <button className="blog-readmore">Read More</button>
        </div>
      </div>

    </div>


    
  </div>
  








</>
  );
}

export default BlogDetail;
